export const resumeData = {
  "main": {
    "name": "Ediz Uslu",
    "occupation": "",
    "description": "passionate and innovative new grad software engineer who possesses a strong fascination in the field of Computer Science with a desire to constantly develop new skills",
    "image": "profilepic.jpg",
    "bio": "Passionate and innovative new grad software engineer who possesses a strong fascination in the field of Computer Science with a desire to constantly develop new skills",
    "contactmessage": "Here is where you should write your message to readers to have them get in contact with you.",
    "email": "edizusluu@gmail.com",
    "phone": "555-555-5555",
    "address": {
      "street": "(Your Street)",
      "city": "(Your City)",
      "state": "(Your State)",
      "zip": "(Your Zip/Postal Code)"
    },
    "website": "http://www.timbakerdev.com",
    "resumedownload": "./images/portfolio/resume.pdf",
    "social": [
      {
        "name": "stackoverflow",
        "url": "https://stackoverflow.com/users/7159763/ediz-uslu",
        "className": "fa fa-stack-overflow"
      },
      {
        "name": "linkedin",
        "url": "https://www.linkedin.com/in/ediz-uslu-93a88312b/",
        "className": "fa fa-linkedin"
      },
      {
        "name": "github",
        "url": "https://github.com/edizuslu",
        "className": "fa fa-github"
      },
      {
        "name": "skype",
        "url": "http://skype.com",
        "className": "fa fa-hackerrank"
      }
    ]
  },
  "resume": {
    "education": [
      {
        "school": "TOBB Economy and Technology University ",
        "degree": "Bachelor's degree, Computer Engineering, 2.93/4.00",
        "graduated": "2015 - 2020",
        "description": ""
      },
      {
        "school": "Nesibe Aydın Anatolian High School",
        "degree": "Department of Science, 86.83/100",
        "graduated": "2012 - 2015",
        "description": ""
      }
    ],
    "work": [
      {
        "company": "JotForm",
        "title": "Software Engineer Intern",
        "years": "Sep 2019 - Dec 2019",
        "description": "→ Key Concepts: Javascript,React (Redux, Hooks),Chrome Extension Development,HTML,CSS\nContributed main product by developing 3rd party apps named JotForm Voice and Random Submission Generator.",
        "icon": "./images/jotform-logo.png"
      },
      {
        "company": "ESEN System & Integration",
        "title": "Software Engineer Intern",
        "years": "Jan 2019 - Apr 2019",
        "description": "→ Key Concepts: Signal Processing, Automatic Voice Segmentation Algorithm Implementation, Database Design and Management, Optimization and Integration of Algorithms, Python, MATLAB, MySQL, Java",
        "icon": "./images/esen-logo-yesil-acik.png"
      },
      {
        "company": "AYESAS Aviation & Aerospace",
        "title": "Software Test Engineer Intern",
        "years": "May 2018 - Aug 2018",
        "description": "→ Key Concepts: Software Test Engineering, Dry Run Process, Acceptance Test, Manual Testing, Performance Monitoringwith Shell Scripting, Java, Documentation",
        "icon": "./images/ayesas-logo.png"
      }
    ],
    "skills": [
      {
        "name": "Languages",
        "desc": " Upper Intermediate (TOEFL ITP – Score:500 - 2015) / Spanish: Beginner"
      },
      {
        "name": "Web development",
        "desc": "JavaScript, ReactJS (Redux, Hooks), NodeJS, React (Redux, Hooks), Express, Flutter, Ruby on Rails,Chrome App/Extension Development, HTML, CSS"
      },
      {
        "name": "Languages related to programming",
        "desc": " Java, Python, C, MATLAB"
      },
      {
        "name": "Database",
        "desc": "MySQL, PostgreSQL"
      },
      {
        "name": "Software & Others",
        "desc": "GIT, Google Services, Heroku, Firebase, SVN, JIRA"
      }
    ]
  },
  "portfolio": {
    "projects": [
      {
        "title": "Senior Project - CarTobbU",
        "category": "Smart car park system for reducing waste of time in car park by recommending parking lots and managingpenalties/complaints in car park of university campus",
        "image": "seniorprojectdemo.PNG",
        "url": "https://www.youtube.com/watch?v=AxiHb0U-UWA&feature=youtu.be&t=468"
      },
      {
        "title": "Loss Adjuster",
        "category": "Car damage detection application which can auto detect dents and scratches in cars according to before and after imagesof the car.",
        "image": "lossadjuster.png",
        "url": "https://raw.githubusercontent.com/edizuslu1/test123/master/foto4.PNG"
      },
      {
        "title": "JotForm Voice",
        "category": "JotForm Voice, a chrome extension which allows to fill forms including different type of form widgets by usingvoice for users with disabilities.",
        "image": "jotvoice.PNG",
        "url": "https://www.youtube.com/watch?v=lV-T9uKOrCg&feature=youtu.be"
      },
      {
        "title": "Random Submission Generator",
        "category": "Random Submission Generator, a developer tool web app developed for developing and testing processes of mainproduct of JotForm.",
        "image": "subgenerator.PNG",
        "url": "https://www.youtube.com/watch?v=DAMnlGtL_Tg&feature=youtu.be"
      },
      {
        "title": "Resisipe",
        "category": "Social media platform for recipes, people can share their recipes, like someone’s recipe, set timer to delete recipe, getnotification when your recipe is liked, search by tags",
        "image": "resisipedemo.PNG",
        "url": "https://www.youtube.com/watch?v=gQBxgU-t8Uc"
      }
    ]
  },
  "testimonials": {
    "testimonials": [
      {
        "text": "Here you should write some nice things that someone has said about you. No lies though, employers can tell when you are lying.",
        "user": "Kareem Abdul Jabbar"
      },
      {
        "text": "That Tim Baker must be one of the most brilliant developers I've ever met! It is amazing that nobody has hired him yet. Hey you, you should hire this guy, he may be fresh out of University and have zero on the job experience but I am confident that he will be one of your best developers in no time!",
        "user": "Steve Wozniak... impersonator"
      }
    ]
  }
}
